import React from 'react';

export interface CacheResults {
  /* The cache stores anything and verifies nothing, so what comes out is
     untyped: the caller asserts what it put under its own key. A key never
     written or since reset can come back as null or undefined: check for both */
  getCacheResultValue: (key: string) => unknown;
  setCacheResultValue: (
    key: string,
    value: unknown,
    reRenderAfterUpdate?: boolean
  ) => void;
  resetCacheResultValue: (key: string) => void;
}

export default React.createContext<CacheResults>({
  getCacheResultValue: () => null,
  setCacheResultValue: () => {},
  resetCacheResultValue: () => {}
});
